import FinanceDashboardTemplate from "Components/templates/finance/dashboard";

const FinanceDashboard = () => {
    document.title = "Finance Dashboard | IbexIQ";
    return <FinanceDashboardTemplate />
}

export default FinanceDashboard;